function isBase64(str = "") {
  return (
    str.startsWith("data:image/jpeg;base64") ||
    str.startsWith("data:image/jpg;base64") ||
    str.startsWith("data:image/png;base64")
  );
}

export default isBase64;
